import { VideoProject } from "@/services/bedrock";

export type KanbanColumnId = "submitted_for_editing" | "editing" | "submitted_for_testing" | "testing" | "completed";

export interface KanbanColumnDef {
  id: KanbanColumnId;
  label: string;
  statuses: VideoProject.Status[];
  sort?: string;
  order?: "asc" | "desc";
}

export const KANBAN_COLUMNS: KanbanColumnDef[] = [
  {
    id: "submitted_for_editing",
    label: "Submitted for Editing",
    statuses: [VideoProject.Status.SUBMITTED_FOR_EDITING],
  },
  {
    id: "editing",
    label: "Editing",
    statuses: [VideoProject.Status.EDITING],
  },
  {
    id: "submitted_for_testing",
    label: "Submitted for Testing",
    statuses: [VideoProject.Status.SUBMITTED_FOR_TESTING],
  },
  {
    id: "testing",
    label: "Testing",
    statuses: [VideoProject.Status.TESTING],
  },
  {
    id: "completed",
    label: "Completed",
    statuses: [
      VideoProject.Status.READY_TO_POST,
      VideoProject.Status.SCHEDULED,
      VideoProject.Status.POSTED,
      VideoProject.Status.POST_FAILED,
    ],
  },
];

const STATUS_TO_COLUMN_ID = new Map<VideoProject.Status, KanbanColumnId>(
  KANBAN_COLUMNS.flatMap(column => column.statuses.map(status => [status, column.id] as const))
);

export function getKanbanColumnId(status: VideoProject.Status): KanbanColumnId | undefined {
  return STATUS_TO_COLUMN_ID.get(status);
}

export function isKanbanCardDraggable(status: VideoProject.Status): boolean {
  return status !== VideoProject.Status.POSTED && status !== VideoProject.Status.POST_FAILED;
}

export function getRepresentativeStatusForColumn(columnId: KanbanColumnId): VideoProject.Status {
  return KANBAN_COLUMNS.find(column => column.id === columnId)!.statuses[0];
}
